import { render, staticRenderFns } from "./Amenities.vue?vue&type=template&id=89e6a526&scoped=true"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"
import style0 from "./Amenities.vue?vue&type=style&index=0&id=89e6a526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e6a526",
  null
  
)

export default component.exports